import request from "../request"
//查询内容列表
export function getContentList(data) {
    return request({
      url: '/news/',
      method:'get',
      params:data
    })
 }


export function monthly(data) {
  return request({
    url: '/news/stats/monthly',
    method:'get',
    params:data
  })
}



// WEBPACK FOOTER //
// ./src/api/navigation.js